export { ClaimDetailModal } from "./ClaimDetailModal";
